(() => {
  const pagePath = window.location.pathname;
  const serviceMap = {
    '/pages/services': 'services_hub',
    '/pages/jewellery-repair-in-hatton-garden-london': 'jewellery_repair',
    '/pages/jewellery-remodelling-in-london': 'jewellery_remodelling',
    '/pages/jewellery-stringing': 'pearl_bead_restringing',
    '/pages/jewellery-resizing-in-london': 'ring_resizing',
    '/pages/jewellery-polishing-in-london': 'jewellery_polishing',
    '/pages/bespoke-jewellery-in-london': 'bespoke_jewellery',
    '/pages/free-jewellery-health-check': 'jewellery_health_check'
  };

  const context = () => ({
    page_path: window.location.pathname,
    service_type: serviceMap[window.location.pathname] || 'other'
  });

  const publish = (eventName, extra = {}) => {
    const payload = Object.assign(context(), extra);

    try {
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish(eventName, payload).catch(() => {});
      }
    } catch (error) {}

    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: eventName }, payload));
      }
    } catch (error) {}
  };

  if (serviceMap[pagePath]) {
    publish('hd_studio:service_page_view');
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.hostname === 'wa.me' || url.hostname.endsWith('.wa.me')) {
      publish('hd_studio:whatsapp_click');
      return;
    }

    if (url.protocol === 'tel:') {
      publish('hd_studio:phone_click');
      return;
    }

    if (url.origin === window.location.origin && url.pathname === '/pages/book-an-appointment') {
      publish('hd_studio:appointment_start');
      return;
    }

    if (url.hostname.includes('google.') && url.pathname.includes('/maps')) {
      const label = (link.textContent || '').trim().toLowerCase();
      publish('hd_studio:google_maps_click', {
        map_action: label.includes('review') ? 'reviews' : label.includes('direction') ? 'directions' : 'map'
      });
    }
  }, { capture: true });
})();
